export default __webpack_public_path__ + "static/media/loginform_v2.eb28e3e1.png";